import { EdgePatientEnrollmentApi } from '@trialcard/apigateway.client/edgePatientEnrollmentApi';
import {
    EnrollPatientRequestModel,
    EnterpriseCoordinatorAccountServiceModelsAccountContactPreferenceModel,
    EnterpriseCoordinatorAccountUpsearchRequestModel,
    EnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel,
    EnterpriseCoordinatorSharedAddressUpsearchModel,
    EnterpriseCoordinatorSharedEmailAddressUpsearchModel,
    EnterpriseCoordinatorSharedPhoneUpsearchModel,
    UpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel,
    UpsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel,
    UpsearchModelEnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel,
    UpsearchModelEnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel,
    UpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel,
    EnterpriseCoordinatorAccountServiceModelsAccountContactUpsearchModel,
} from '@trialcard/apigateway.models';
import { Gender, RoleType } from '@trialcard/enums';
import { Resolve } from 'vue-di';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { Action, Mutation } from 'vuex-module-decorators';

import { EdgeEnrollmentApi } from '@trialcard/apigateway.client';
import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import moment, { Moment } from 'moment';
import { PDFDocument } from 'pdf-lib';
import { EdgeDocumentsApi } from '@trialcard/apigateway.client/edgeDocumentsApi';
import { string, boolean } from 'yargs';
import { Settings } from '~/services/settings';
import SurveyModule from '~/store/survey';
import genders from '~/assets/genders';
import PharmacyEligibilityModule from '~/store/pharmacy-eligibility';
import EligibilityModule from '~/store/eligibility';

@InjectModule({ stateFactory: true }, module)
export default class EnrollmentModule extends InjectVuexModule {
    setEyeCareQuestionOne(eyeCareQuestionOne: boolean | null) {
        throw new Error('Method not implemented.');
    }
    @Resolve
    public patientEnrollmentApi!: EdgePatientEnrollmentApi;

    @Resolve
    public enrollmentApi!: EdgeEnrollmentApi;

    @Resolve
    public settings!: Settings;

    @Resolve
    public survey!: SurveyModule;

    @Resolve
    edgeDocumentsApi!: EdgeDocumentsApi;

    @Resolve
    public hcpPharmacyeligibility!: PharmacyEligibilityModule;

    @Resolve
    public patientEligibility!: EligibilityModule;

    defaultPatientInformationData = {
        firstName: '' as string,
        lastName: '' as string,
        dateOfBirth: null as Moment | null,
        addresses: [] as EnterpriseCoordinatorSharedAddressUpsearchModel[],
        emailAddresses: [] as EnterpriseCoordinatorSharedEmailAddressUpsearchModel[],
        phoneNumbers: [] as EnterpriseCoordinatorSharedPhoneUpsearchModel[],
        gender: null as Gender | null,
    };

    defaultInsuranceInformationData = {
        insuranceProvider: '' as string,
        phone: '' as string,
        cardHolderName: '' as string,
        dateOfBirth: '' as string,
        policy: '' as string,
        group: '' as string,
        optInsuranceProvider: '' as string,
        optPhone: '' as string,
        optCardHolderName: '' as string,
        optDateOfBirth: '' as string,
        optPolicy: '' as string,
        optGroup: '' as string
    }

    defaultCareGiverInformationData = {
        careGiverName: '' as string,
        phone: '' as string,
        relationShipToPatient: '' as string,
    };

    defaultHCPInsuranceInformationData = {
        hcpInsuranceProvider: '' as string,
        hcpPhone: '' as string,
        hcpCardHolderName: '' as string,
        hcPDateOfBirth: '' as string,
        hcpPolicy: '' as string,
        hcpGroup: '' as string,
        hcpOptInsuranceProvider: '' as string,
        hcpOptPhone: '' as string,
        hcpOptCardHolderName: '' as string,
        hcpOptDateOfBirth: '' as string,
        hcpOptPolicy: '' as string,
        hcpOptGroup: '' as string
    }

    defaultPrescriberSiteInformationData = {
        prescriberSiteLastName: '' as string,
        firstName: '' as string,
        specialty: '' as string,
        taxId: '' as string,
        npi: '' as string,
        stateLicense: '' as string,
        practiceName: '' as string,
        street: '' as string,
        city: '' as string,
        state: '' as string,
        zip: '' as string,
        contactName: '' as string,
        phone: '' as string,
        ext: '' as string,
        email: '' as string,
        siteFax: '' as string,
        facultyName: '' as string,
        optPhone: '' as string,
        optStreet: '' as string,
        optCity: '' as string,
        optState: '' as string,
        optZip: '' as string,
        contactEmail: '' as string,
    }

    defaultPrescriberData = [
        {
            model: {
                firstName: '',
                lastName: '',
                npi: '',
                accountRelationshipIsPrimary: true,
                prescriberLicenses: [],
                externalIds: [],
                addresses: [],
                phoneNumbers: [],
                emailAddresses: [],
            },
        },
    ] as UpsearchModelEnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel[];

    defaultSiteData = [
        {
            model: {
                accountRelationshipIsPrimary: true,
                siteRoleType: RoleType.PrescriberSite,
                pointOfContacts: [],
                description: '',
                addresses: [
                    {
                        addressOne: '',
                        addressTwo: '',
                        zip: '',
                        city: '',
                        state: '',
                    },
                ],
                contacts: [],
                emailAddresses: [],
                externalIds: [],
                phoneNumbers: [],
                globalIds: [],
            },
        },
    ] as UpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel[];

    defaultPayorData = [
        {
            model: {
                payorId: (null as unknown) as number,
                payorType: (null as unknown) as number,
                accountRelationshipIsPrimary: true,
                payorGroup: '',
                payorName: '',
                webAddresses: [],
                addresses: [],
                phoneNumbers: [
                    {
                        phoneType: 1,
                        phoneNumber: '',
                        phonePurpose: 1,
                    },
                    {
                        phoneType: 3,
                        phoneNumber: '',
                        phonePurpose: 8,
                    },
                ],
                emailAddresses: [],
                contacts: [],
                payorBenefit: {
                    dateOfBirth: null as Moment | null,
                    policyHolderFirstName: '',
                    policyHolderLastName: '',
                    relationshipToPatient: undefined,
                    policyNumber: '',
                    planType: undefined,
                },
            },
        },
    ] as UpsearchModelEnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel[];
    // defaultNcpdp = '';

    defaultContactPreferences = [] as EnterpriseCoordinatorAccountServiceModelsAccountContactPreferenceModel[];
    defaultContacts = [] as EnterpriseCoordinatorAccountServiceModelsAccountContactUpsearchModel[];

    defaultMemberNumbers = {
        medical: 'xxxxxxxxxxxx',
        pharmacy: 'xxxxxxxxxxxx',
    };
    defaultMemberNumber = 'xxxxxxxxxxxx';
    defaultExpirationDate = moment();
    pharmaMemberNumber = this.defaultMemberNumbers.pharmacy;
    medicalMemberNumber = this.defaultMemberNumbers.medical;

    public defaultAuthorizationData = {
        consentCheckbox: false as boolean,
        tncCheckbox: false as boolean,
        fcraCheckbox: false as boolean,
        tcpaConsentCheckbox: false as boolean,
        FName: '',
        LName: '',
    };

    public defaultMorePatientInfoData = {
        preferredTimeMrng: false as boolean,
        preferredTimeAfternoon: false as boolean,
        preferredTimeEvening: false as boolean,
        voicemail: false as boolean,
        optIn: false as boolean,
        optInMarketingnonRemission: false as boolean,
        optInMarketingRelapse: false as boolean,
        optInEmail: '' as string,
        alternateContactName: '' as string,
        alternateContactPhone: '' as string,
        relationShipToPatient: '' as string,
    }

    public defaultPatientSupportServicesData = {
        eyeCareQuestionOne: null as null | boolean,
        eyeCareDropQuestionTwo: null as null | boolean,
        ecpName: '',
        patientSupportPhone: '',
        mailingAddress: '',
        facilityName: '',
        patientSupportFax: '',
        agreeText: false as boolean,
        city: '' as string,
        state: '' as string,
        zip: '' as string
    }
    
    public defaultHcpSupportServicesData = {
        eyeCareQuestionOne: null as null | boolean,
        eyeCareDropQuestionTwo: null as null | boolean,
        ecpName: '',
        patientSupportPhone: '',
        mailingAddress: '',
        facilityName: '',
        patientSupportFax: '',
        agreeText: false as boolean,
        city: '' as string,
        state: '' as string,
        zip: '' as string
    }

    public defaultHcpPatientInformationData = {
        hcpFirstName: '' as string,
        hcpLastName: '' as string,
        hcpStreet: '' as string,
        hcpZip: '' as string,
        hcpCity: '' as string,
        hcpState: '' as string,
        hcpEmail: '' as string,
        hcpDateOfBirth: '' as string,
        hcpLanguage: '' as string,
        hcpGender: null as null | number,
        hcpPreferredPhone: '' as string,
        hcpPhoneType: '' as string,

        preferredTimeMrng: false as boolean,
        preferredTimeAfternoon: false as boolean,
        preferredTimeEvening: false as boolean,
        voicemail: false as boolean,

        hcpAlternateName: '' as string,
        hcpAlternatePhone: '' as string,
        hcpAlternateRelationship: '' as string,
    }

    memberNumber = this.defaultMemberNumber;
    expirationDate = this.defaultExpirationDate;
    patientInformationData = { ...this.defaultPatientInformationData };
    insuranceInformationData = { ...this.defaultInsuranceInformationData }
    careGiverInformationData = { ...this.defaultCareGiverInformationData };
    hcpInsuranceInformationData = { ...this.defaultHCPInsuranceInformationData }
    prescriberSiteInformationData = { ...this.defaultPrescriberSiteInformationData }
    prescriberData = [...this.defaultPrescriberData];
    siteData = [...this.defaultSiteData];
    payorData = [...this.defaultPayorData];
    contactPreferences = [...this.defaultContactPreferences];
    AuthorizationData = { ...this.defaultAuthorizationData };
    isCareGiver = false as boolean;
    contacts = [...this.defaultContacts] as EnterpriseCoordinatorAccountServiceModelsAccountContactUpsearchModel[];
    ncpdp = '';
    pharmacySignature = '' as string;
    prescriberSignature = '' as string;
    showEyeCareAndDropSupportInformationData = null as null | boolean
    morePatientInfoData = { ...this.defaultMorePatientInfoData };
    hcpPatientInformationData = { ...this.defaultHcpPatientInformationData };
    optedInOncologistInformation = null as null | boolean
    patientSupportServicesData = { ...this.defaultPatientSupportServicesData };
    hcpSupportServicesData = { ...this.defaultHcpSupportServicesData };


    @Mutation
    public async updatePatientSupportServicesInformation(newPatientSupportServicesInformation: typeof EnrollmentModule.prototype.defaultPatientSupportServicesData) {
        this.patientSupportServicesData = newPatientSupportServicesInformation;
    }
    
    @Mutation
    public async updateHcpSupportServicesInformation(newHcpSupportServicesInformation: typeof EnrollmentModule.prototype.defaultHcpSupportServicesData) {
        this.hcpSupportServicesData = newHcpSupportServicesInformation;
    }

    // HCP insurance information
    @Mutation
    public async updateHCPInsuranceInformation(newInsuranceInformation: typeof EnrollmentModule.prototype.hcpInsuranceInformationData) {
        this.hcpInsuranceInformationData = { ...this.hcpInsuranceInformationData, ...newInsuranceInformation };
    }

    selectInsuranceOption = '' as string;

    @Mutation
    public setInsuranceInfoFlag(optionAnswer: string) {
        this.selectInsuranceOption = optionAnswer;
    }

    // Prescriber site information
    selectPrescriberSiteOption = false as boolean;

    @Mutation
    public setInfoSiteFlag(optionAnswer: boolean) {
        this.selectPrescriberSiteOption = optionAnswer;
    }

    @Mutation
    public async updatePrescriberSiteInformation(newPrescriberSiteInformation: typeof EnrollmentModule.prototype.prescriberSiteInformationData) {
        this.prescriberSiteInformationData = { ...this.prescriberSiteInformationData, ...newPrescriberSiteInformation };
    }

    @Mutation
    public async updateMorePatientInfoData(newPatientInfo: typeof EnrollmentModule.prototype.defaultMorePatientInfoData) {
        this.morePatientInfoData = newPatientInfo;
    }

    @Mutation
    public async updateHcpPatientInformationData(newHcpPatientInformation: typeof EnrollmentModule.prototype.defaultHcpPatientInformationData) {
        this.hcpPatientInformationData = newHcpPatientInformation;
    }

    @Mutation
    public setPharmaMemberNumber(pharmaMemberNumber: string) {
        this.pharmaMemberNumber = pharmaMemberNumber;
    }

    @Mutation
    public setMedicalMemberNumber(medicalMemberNumber: string) {
        this.medicalMemberNumber = medicalMemberNumber;
    }

    @Mutation
    updateAuthorizationData(newAuthorizationData: typeof EnrollmentModule.prototype.defaultAuthorizationData) {
        this.AuthorizationData = { ...newAuthorizationData };
    }

    @Mutation
    public async updateContacts(newContacts: EnterpriseCoordinatorAccountServiceModelsAccountContactUpsearchModel[]) {
        this.contacts = newContacts;
    }

    @Mutation
    public async updatePatientInformation(newPatientInformation: typeof EnrollmentModule.prototype.patientInformationData) {
        this.patientInformationData = { ...this.patientInformationData, ...newPatientInformation };
    }

    // insurance information
    @Mutation
    public async updateInsuranceInformation(newInsuranceInformation: typeof EnrollmentModule.prototype.insuranceInformationData) {
        this.insuranceInformationData = { ...this.insuranceInformationData, ...newInsuranceInformation };
    }

    @Mutation
    public async updatePrescribers(newPrescriberData: UpsearchModelEnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel[]) {
        this.prescriberData = [...newPrescriberData];
    }

    @Mutation
    public async updateSites(newSites: UpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel[]) {
        this.siteData = [...newSites];
    }

    @Mutation
    public async updatePayors(newPayorData: UpsearchModelEnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel[]) {
        this.payorData = [...newPayorData];
    }

    @Mutation
    public async updateCareGiverInformation(newCareGiverInformation: typeof EnrollmentModule.prototype.careGiverInformationData) {
        this.careGiverInformationData = { ...this.patientInformationData, ...newCareGiverInformation };
    }

    @Mutation
    public async updateContactPreferences(newContactPreferences: EnterpriseCoordinatorAccountServiceModelsAccountContactPreferenceModel[]) {
        this.contactPreferences = [...newContactPreferences];
    }

    @Mutation
    public setMemberNumber(memberNumber: string) {
        this.memberNumber = memberNumber;
    }

    @Mutation
    public setNcpdp(ncpdp: string) {
        this.ncpdp = ncpdp;
    }

    @Mutation
    public setPharmacySignature(pharmacySignature: string) {
        this.pharmacySignature = pharmacySignature;
    }

    @Mutation
    public setPrescriberSignature(prescriberSignature: string) {
        this.prescriberSignature = prescriberSignature;
    }

    @Mutation
    public setExpirationDate(expirationDate: Moment) {
        this.expirationDate = expirationDate;
    }

    @Mutation
    public setIsCareGiver(isCareGiver: boolean) {
        this.isCareGiver = isCareGiver;
    }
    optSharedInformation = null as null | boolean

    @Mutation
    public setSharedInfoFlag(sharedInfoAnswer: null | boolean) {
        this.optSharedInformation = sharedInfoAnswer;
    }

    @Mutation
    public setOncologistFlag(oncologyOptedAnswer: null | boolean) {
        this.optedInOncologistInformation = oncologyOptedAnswer;
    }

    @Action({ rawError: true })
    public clearStore() {
        this.setMemberNumber(this.defaultMemberNumber);
        this.setPharmaMemberNumber(this.defaultMemberNumbers.pharmacy);
        this.setMedicalMemberNumber(this.defaultMemberNumbers.medical);
        this.setExpirationDate(this.defaultExpirationDate);
        this.updatePatientInformation(this.defaultPatientInformationData);
        this.updateCareGiverInformation(this.defaultCareGiverInformationData);
        this.updatePrescribers(this.defaultPrescriberData);
        this.updateSites(this.defaultSiteData);
        this.updatePayors(this.defaultPayorData);
        this.updateContactPreferences(this.defaultContactPreferences);
        this.updateAuthorizationData(this.defaultAuthorizationData);
        this.setIsCareGiver(false);
        this.hcpPharmacyeligibility.clearStore();
        this.patientEligibility.clearStore();
        this.setNcpdp('');
        this.updateContacts(this.defaultContacts);
        this.setPharmacySignature('');
        this.setPrescriberSignature('');
        this.updatePatientSupportServicesInformation(this.defaultPatientSupportServicesData);
        this.updateHcpSupportServicesInformation(this.defaultHcpSupportServicesData);
        this.setInsuranceInfoFlag('');
        this.updateInsuranceInformation(this.defaultInsuranceInformationData);
        this.setSharedInfoFlag(null)
        this.updateMorePatientInfoData(this.defaultMorePatientInfoData);
        this.updateHcpPatientInformationData(this.defaultHcpPatientInformationData);
        this.setOncologistFlag(null)
        this.updatePatientSupportServicesInformation(this.defaultPatientSupportServicesData);
        this.updateHcpSupportServicesInformation(this.defaultHcpSupportServicesData);
    }

    @Action({ rawError: true })
    public clearEnrollment() {
        this.updatePatientInformation({ ...this.defaultPatientInformationData });
        this.setMemberNumber(this.defaultMemberNumber);
        this.setPharmaMemberNumber(this.defaultMemberNumbers.pharmacy);
        this.setMedicalMemberNumber(this.defaultMemberNumbers.medical);
        this.updateAuthorizationData(this.defaultAuthorizationData);
        this.setNcpdp('');
        this.setPharmacySignature('');
        this.setPrescriberSignature('');
        this.updatePatientSupportServicesInformation({ ...this.defaultPatientSupportServicesData });
        this.updateHcpSupportServicesInformation({ ...this.defaultHcpSupportServicesData });
        this.updateMorePatientInfoData({ ...this.defaultMorePatientInfoData });
        this.updateHcpPatientInformationData({ ...this.defaultHcpPatientInformationData })
        this.setOncologistFlag(null)
    }

    @Action({ rawError: true })
    public async submitToAPI() {
        let response = null;
        const { prescriberData, siteData, payorData, contactPreferences } = this;
        try {
            const patient = {
                account: {
                    patientData: {
                        canUpdate: true,
                        canInsert: true,
                        skipSearch: false,
                        model: {
                            ...this.patientInformationData,
                            middleName: '',
                            suffix: '',
                            nickname: '',
                        } as EnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel,
                    } as UpsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel,
                    accountData: {
                        canUpdate: true,
                        canInsert: true,
                        skipSearch: false,
                        model: {
                            accountType: 1,
                            accountStatus: 1,
                            contactPreferences,
                            contacts: this.contacts,
                        },
                    } as UpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel,
                    surveySessionData: [this.survey.sessionId] as number[],
                } as EnterpriseCoordinatorAccountUpsearchRequestModel,
                accountAttestations: [
                    {
                        code: 'eServiceAttestion',
                        startDate: moment(),
                    },
                ]
            } as EnrollPatientRequestModel;

            const axios: AxiosInstance = (this.patientEnrollmentApi as any).axios;
            const axiosRequest: AxiosRequestConfig = {
                url: '/edge/patientEnrollment/enrollPatient',
                method: 'POST',
                data: patient,
                headers: {
                    'x-program-id': this.settings.programId!,
                },
            };
            await Promise.all([
                (this.patientEnrollmentApi as any).authentications.ApiKey.applyToRequest(axiosRequest),
                (this.patientEnrollmentApi as any).authentications.Bearer.applyToRequest(axiosRequest),
                (this.patientEnrollmentApi as any).authentications.Token.applyToRequest(axiosRequest),
            ]);
            response = await axios.request(axiosRequest);
        } catch {
            response = { status: 400 } as AxiosResponse;
        }
        return response;
    }

    async writePdf() {
        if (this.isCareGiver) {
            const pdfArrayRes = await fetch(this.settings.url('/patient-authorization-for-juvenile.pdf'));
            const formBytes = await pdfArrayRes.arrayBuffer();
            const baseDoc = await PDFDocument.load(formBytes);
            const form = baseDoc.getForm();
            const gender = genders.find(gender => gender.id === this.patientInformationData.gender);
            const address = this.patientInformationData.addresses.length > 0 ? this.patientInformationData.addresses[0] : {};
            const dateOfBirth = this.patientInformationData.dateOfBirth
                ? moment.utc(this.patientInformationData.dateOfBirth || '', ['MM/DD/YYYY', 'YYYY-MM-DD'])
                : moment();
            form.getTextField('patientFirstName').setText(this.patientInformationData.firstName);
            form.getTextField('patientFirstName').enableReadOnly();
            form.getTextField('patientLastName').setText(this.patientInformationData.lastName);
            form.getTextField('patientLastName').enableReadOnly();
            form.getTextField('patientGender').setText((gender && gender.name) || '');
            form.getTextField('patientGender').enableReadOnly();
            form.getTextField('patientDateOfBirth').setText(dateOfBirth.format('L'));
            form.getTextField('patientDateOfBirth').enableReadOnly();
            form.getTextField('patientAddressLine1').setText(address.addressOne);
            form.getTextField('patientAddressLine1').enableReadOnly();
            form.getTextField('patientAddressLine2').setText(address.addressTwo || '');
            form.getTextField('patientAddressLine2').enableReadOnly();
            form.getTextField('patientZipCode').setText(address.zip);
            form.getTextField('patientZipCode').enableReadOnly();
            form.getTextField('patientCity').setText(address.city);
            form.getTextField('patientCity').enableReadOnly();
            form.getTextField('patientState').setText(address.state);
            form.getTextField('patientState').enableReadOnly();
            form.getTextField('patientParentOrGuardianName').enableReadOnly();
            form.getTextField('patientParentOrGuardianRelationshipToPatient').setText(this.careGiverInformationData.relationShipToPatient);
            form.getTextField('patientParentOrGuardianRelationshipToPatient').enableReadOnly();
            form.getTextField('patientParentOrGuardianMobilePhone').enableReadOnly();
            form.getTextField('patientParentOrGuardianHomePhone').enableReadOnly();
            form.getTextField('patientParentOrGuardianEmail').enableReadOnly();
            if (this.AuthorizationData.consentCheckbox) {
                form.getCheckBox('patientAuthorizationCheckbox1').check();
                form.getCheckBox('patientAuthorizationCheckbox1').enableReadOnly();
            } else {
                form.getCheckBox('patientAuthorizationCheckbox1').enableReadOnly();
            }
            if (this.AuthorizationData.tncCheckbox) {
                form.getCheckBox('patientAuthorizationCheckbox2').check();
                form.getCheckBox('patientAuthorizationCheckbox2').enableReadOnly();
            } else {
                form.getCheckBox('patientAuthorizationCheckbox2').enableReadOnly();
            }
            if (this.AuthorizationData.tcpaConsentCheckbox) {
                form.getCheckBox('patientAuthorizationCheckbox3').check();
                form.getCheckBox('patientAuthorizationCheckbox3').enableReadOnly();
            } else {
                form.getCheckBox('patientAuthorizationCheckbox3').enableReadOnly();
            }
            if (this.AuthorizationData.fcraCheckbox) {
                form.getCheckBox('patientAuthorizationCheckbox4').check();
                form.getCheckBox('patientAuthorizationCheckbox4').enableReadOnly();
            } else {
                form.getCheckBox('patientAuthorizationCheckbox4').enableReadOnly();
            }
            form.getTextField('patientAuthorizationFirstName').setText(this.AuthorizationData.FName);
            form.getTextField('patientAuthorizationFirstName').enableReadOnly();
            form.getTextField('patientAuthorizationLastName').setText(this.AuthorizationData.LName);
            form.getTextField('patientAuthorizationLastName').enableReadOnly();
            form.getTextField('patientAuthorizationTodayDate').setText(moment().format('L'));
            form.getTextField('patientAuthorizationTodayDate').enableReadOnly();

            const exportBytes = await baseDoc.save();
            return exportBytes;
        } else {
            const pdfArrayRes = await fetch(this.settings.url('/patient-authorization-for-non-juvenile.pdf'));
            const formBytes = await pdfArrayRes.arrayBuffer();
            const baseDoc = await PDFDocument.load(formBytes);
            const form = baseDoc.getForm();
            const gender = genders.find(gender => gender.id === this.patientInformationData.gender);
            const address = this.patientInformationData.addresses.length > 0 ? this.patientInformationData.addresses[0] : {};
            const patientMobilePhone =
                this.patientInformationData.phoneNumbers.length > 0 ? this.patientInformationData.phoneNumbers[0] : {};
            const patientHomePhone = this.patientInformationData.phoneNumbers.length > 0 ? this.patientInformationData.phoneNumbers[1] : {};
            const parentEmail = this.patientInformationData.emailAddresses.length > 0 ? this.patientInformationData.emailAddresses[0] : {};
            const dateOfBirth = this.patientInformationData.dateOfBirth
                ? moment.utc(this.patientInformationData.dateOfBirth || '', ['MM/DD/YYYY', 'YYYY-MM-DD'])
                : moment();
            form.getTextField('patientFirstName').setText(this.patientInformationData.firstName);
            form.getTextField('patientFirstName').enableReadOnly();
            form.getTextField('patientLastName').setText(this.patientInformationData.lastName);
            form.getTextField('patientLastName').enableReadOnly();
            form.getTextField('patientGender').setText((gender && gender.name) || '');
            form.getTextField('patientGender').enableReadOnly();
            form.getTextField('patientDateOfBirth').setText(dateOfBirth.format('L'));
            form.getTextField('patientDateOfBirth').enableReadOnly();
            form.getTextField('patientAddressLine1').setText(address.addressOne);
            form.getTextField('patientAddressLine1').enableReadOnly();
            form.getTextField('patientAddressLine2').setText(address.addressTwo || '');
            form.getTextField('patientAddressLine2').enableReadOnly();
            form.getTextField('patientZipCode').setText(address.zip);
            form.getTextField('patientZipCode').enableReadOnly();
            form.getTextField('patientCity').setText(address.city);
            form.getTextField('patientCity').enableReadOnly();
            form.getTextField('patientState').setText(address.state);
            form.getTextField('patientState').enableReadOnly();
            form.getTextField('patientMobilePhone').setText(patientMobilePhone.phoneNumber);
            form.getTextField('patientMobilePhone').enableReadOnly();
            form.getTextField('patientHomePhone').setText(patientHomePhone?.phoneNumber || '');
            form.getTextField('patientHomePhone').enableReadOnly();
            form.getTextField('patientEmailAddress').setText(parentEmail.address || '');
            form.getTextField('patientEmailAddress').enableReadOnly();
            if (this.AuthorizationData.consentCheckbox) {
                form.getCheckBox('patientAuthorizationCheckbox1').check();
                form.getCheckBox('patientAuthorizationCheckbox1').enableReadOnly();
            } else {
                form.getCheckBox('patientAuthorizationCheckbox1').enableReadOnly();
            }
            if (this.AuthorizationData.tncCheckbox) {
                form.getCheckBox('patientAuthorizationCheckbox2').check();
                form.getCheckBox('patientAuthorizationCheckbox2').enableReadOnly();
            } else {
                form.getCheckBox('patientAuthorizationCheckbox2').enableReadOnly();
            }
            if (this.AuthorizationData.tcpaConsentCheckbox) {
                form.getCheckBox('patientAuthorizationCheckbox3').check();
                form.getCheckBox('patientAuthorizationCheckbox3').enableReadOnly();
            } else {
                form.getCheckBox('patientAuthorizationCheckbox3').enableReadOnly();
            }
            if (this.AuthorizationData.fcraCheckbox) {
                form.getCheckBox('patientAuthorizationCheckbox4').check();
                form.getCheckBox('patientAuthorizationCheckbox4').enableReadOnly();
            } else {
                form.getCheckBox('patientAuthorizationCheckbox4').enableReadOnly();
            }
            form.getTextField('patientAuthorizationFirstName').setText(this.AuthorizationData.FName);
            form.getTextField('patientAuthorizationFirstName').enableReadOnly();
            form.getTextField('patientAuthorizationLastName').setText(this.AuthorizationData.LName);
            form.getTextField('patientAuthorizationLastName').enableReadOnly();
            form.getTextField('patientAuthorizationTodayDate').setText(moment().format('L'));
            form.getTextField('patientAuthorizationTodayDate').enableReadOnly();

            const exportBytes = await baseDoc.save();
            return exportBytes;
        }
    }
    public async uploadPdf(blob: Blob) {
        const formData = new FormData();
        formData.append('type', '10001');
        formData.append('attachment', blob);

        formData.append('externalPartyCode', 'CLS');
        formData.append('externalProgramCode', 'HYRI');
        const axios: AxiosInstance = (this.edgeDocumentsApi as any).axios;
        const axiosRequest: AxiosRequestConfig = {
            url: 'edge/documents/v1/Document/upload',
            method: 'POST',
            data: formData,
            headers: {
                'x-program-id': this.settings.clsProgramId!,
            },
        };

        await Promise.all([
            // (this.edgeDocumentsApi as any).authentications.ApiKey.applyToRequest(axiosRequest),
            // (this.edgeDocumentsApi as any).authentications.Bearer.applyToRequest(axiosRequest),
            (this.edgeDocumentsApi as any).authentications.Token.applyToRequest(axiosRequest),
        ]);

        const result = await axios.request(axiosRequest);
        return result;
    }
}
